export type ThemeVariant = 'v19' | 'v26'

let currentThemeVariant: ThemeVariant | undefined

export function setCurrentThemeVariant(
    themeVariant: ThemeVariant | undefined
): void {
    currentThemeVariant = themeVariant
}

export function getCurrentThemeVariant(): ThemeVariant | undefined {
    return currentThemeVariant
}
